import axios from "axios";
import Mustache from 'mustache';

function debounce(func, wait, immediate) {
  var timeout;

  return function () {
    var context = this;
    var args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}

var debounceSearch = debounce(function() {
    $.ajax({
      url: '/courses/search/',
      data: {
        terms: $('#course_terms').val(),
        subject_area_id: $('#subject_area_id').val()
      }
    }).done(function(response) {
      var template = document.getElementById('course_search_tmpl').innerHTML;
      var rendered = Mustache.render(template, { courses: response });
      $('#course_results').html(rendered);

    }).fail(function() {
      $('#course_results').html("Couldn't load results");
    }).always(function() {

    });
}, 250);

function setActiveFilters() {
    let type_filter = $('#type_filter option:selected').text();
    let sa_filter = $('#sa_filter option:selected').text();
    const all = 'All';

    $('.active-filters').text('');
    let filter_text = '';
    if(type_filter != all || sa_filter != all) {
      filter_text = 'Searching';

      if (type_filter !== all) {
        filter_text += ` for ${type_filter}s`;
      }

      if (sa_filter !== all) {
        filter_text += ` in ${sa_filter}`;
      }

      $('.active-filters').text(filter_text);
    }
}

var debounceAllSearch = debounce(function(page) {
    //page represents page no of result set
    let load_more = (page === undefined) ? false : true;
    let next_page = null;
    if(load_more) {
      next_page = parseInt(page) + 1;
    }

    let type_filter = $('#type_filter').val();
    let sa_filter = $('#sa_filter').val();

    setActiveFilters();

    if(!load_more) {
      $('.search-all-wrapper .results-wrapper').hide();
    }

    $('.search-all-wrapper .loader').show();
    $('.search-all-wrapper .load-more').hide();

    $('#error').hide();

    axios.get('/api/search_all/', { params: {
      terms: $('#all_terms').val(),
      search_page: next_page,
      type_filter: type_filter,
      sa_filter: sa_filter
    }}).then(function(response) {
      $('.search-all-wrapper .loader').hide();
      var template = document.getElementById('all_search_tmpl').innerHTML;
      var rendered = Mustache.render(template, { results: response.data.results });

      if(!load_more) {
         $('#all_results').empty();
      }

      $('#all_results').append(rendered);
      $('.search-all-wrapper .load-more').attr('data-current_page', response.data.page);
      $('.search-all-wrapper .results-wrapper').show();

      if(response.data.page !== response.data.total_pages) {
        $('.search-all-wrapper .load-more').show();
      }
    }).catch(function(err) {
      $('.search-all-wrapper .loader').hide();
      $('#error').show();
    });
}, 500);

var debounceTabletStructure = debounce(function() {
    let pad_top = 40;
    let pad_intial = 10;
    let right_pos = 0;
    let mobile_breakpoint = 767;

    let current_top_pos = pad_intial;

    let media_query = window.matchMedia(`(max-width: ${mobile_breakpoint}px)`);

    if(media_query.matches) {
      $('section.tablet-right').removeClass('positioned');
    }else{
      $('section.tablet-right').each(function() {
        let sec = $(this);
        let height = sec.height();

        if(!sec.hasClass('positioned')) {
          sec.addClass('positioned');
          sec.css('right', right_pos);
          sec.css('top', current_top_pos + 'px');

          current_top_pos = current_top_pos + height + pad_top;
        }
      });
    }
}, 250);

export {
  debounce,
  debounceSearch,
  debounceAllSearch,
  debounceTabletStructure
};